import { Injectable } from '@angular/core';

import { OfferSource } from '@cds';
import { isDefined } from '@frontend/sports/common/core/utils/extended-types';
import { keyBy } from 'lodash-es';

import { BetslipType } from '../../../../../core/betslip-type';
import { BetslipBetBuilderPick } from '../../../../../core/picks/betslip-bet-builder-pick';
import { BaseBetslipGroupPick } from '../../../../../core/picks/betslip-group-pick';
import { BetslipPick } from '../../../../../core/picks/betslip-pick';
import { BetslipV1Pick } from '../../../../../core/picks/betslip-v1-pick';
import { BetslipV2OptionMarketPick } from '../../../../../core/picks/betslip-v2-option-market-pick';
import { BetslipV2GolfWinParticipantPick } from '../../../../../core/picks/sport-specific/betslip-v2-golf-picks';
import { CriteriaType, IRewardToken } from '../../../reward-tokens.model';
import { TokenPicksValidity, TokenValidationInput, TokensCriteriaValidatorBase, picksValidity } from '../criteria-validator-base.service';

@Injectable()
export class FixturesValidator extends TokensCriteriaValidatorBase<IRewardToken, CriteriaType> {
    override type = CriteriaType.Fixtures;
    isValid(token: IRewardToken, state: TokenValidationInput): TokenPicksValidity {
        const picks = state.selectedPicks;

        if (!token.filter?.fixtures?.length) {
            return picksValidity(true, picks);
        }

        const eligibleFixtureIds = keyBy(token.filter.fixtures, (fixture) => fixture.id);

        const validPicks = picks.filter((pick) => {
            const fixtureId = this.getFixtureId(pick);

            return isDefined(fixtureId) && !!eligibleFixtureIds[fixtureId];
        });

        if (state.selectedType === BetslipType.Single || state.selectedType === BetslipType.BetBuilder) {
            return picksValidity(validPicks.length > 0, validPicks);
        }

        return picksValidity(validPicks.length > 0 && validPicks.length === picks.length, validPicks);
    }

    private getFixtureId(pick: BetslipPick): string | undefined {
        if (BetslipBetBuilderPick.isPick(pick)) {
            return pick.event.source === OfferSource.V1 ? pick.id.eventId : pick.id.fixtureId;
        }
        if (BaseBetslipGroupPick.isPick(pick)) {
            return pick.eventId;
        }
        if (BetslipV1Pick.isPick(pick)) {
            return pick.event.id;
        }
        if (BetslipV2OptionMarketPick.isPick(pick) || BetslipV2GolfWinParticipantPick.isPick(pick)) {
            return pick.fixture.fixtureId;
        }

        return;
    }
}
